import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=1b87d7c4&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&id=1b87d7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87d7c4",
  null
  
)

export default component.exports